import axios from 'axios';

import {
    KYB_API_BASE_URL
} from '../../constants/index';
import UrlUtils from 'src/services/utils/UrlUtils';

export default class KYBService {
    static instance;
    resource = `${KYB_API_BASE_URL}/kyb`;

    static getInstance() {
        if (!KYBService.instance) {
            KYBService.instance = new KYBService();
        }

        return KYBService.instance;
    }

    async searchOrganizations(organizationId, params = {}){
        const response = await axios.get(`${this.resource}/supplier/${organizationId}/companies`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data
    } 

    async fetchCachedOrganizations(organizationId, params = {}){
        const response = await axios.get(`${this.resource}/supplier/${organizationId}/selected-companies`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data
    } 

    async fetchOrgFromProvider(orgIdInSource, params = {}){
        const response = await axios.get(`${this.resource}/supplier/${orgIdInSource}/fetch-from-source`, {
            params: params,
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data
    } 

    async getFetchedOrgDetails(orgIdInSource, provider, supplierId = null){
        const urlUtils = new UrlUtils();

        // if (provider === 'dun_brad_street_enterprise') {
        //     return await (new Promise((res) => {
        //         setTimeout(() => {
        //             res({
        //                 "company": {
        //                     "source": "dun_brad_street_enterprise",
        //                     "organizationData": '{"parent":{"duns":"269804284","country":"FR","dnb_key":"1f9376aaa698c935f00706690af205ee","trade_name":"COSMELUX INTERNATIONAL"},"inventory":863282,"net_income":1246331,"quickcheck":{"city":"JUVIGNY","duns":"277361135","sales":13360288,"region":"AUVERGNE RHONE ALPES","address":["269 RUE GEORGES CHARPAK"],"country":"FR","dnb_key":"1054cf827b0852cf258f9c970626c6e7","ceo_name":"COSMELUX HOLDCO","currency":"EUR","disaster":false,"postcode":"74100","ceo_title":"President","net_worth":13739190,"subregion":"HAUTE-SAVOIE","dnb_rating":"FF2","legal_form":"LSC/167","start_year":1971,"trade_name":"LABLABO","paydex_norm":77,"sic_version":"1987","enquiry_duns":"277361135","other_events":false,"paydex_score":80,"phone_number":"04 50 95 20 90","maximum_credit":8600,"suit_judgement":false,"business_number":"71202304300052","employees_total":{"employees":50,"estimated":false,"subsidiaries_included":false},"out_of_business":false,"secured_filings":false,"intangible_assets":390118,"sic_activity_code":"3089","incorporation_year":1971,"operational_events":true,"local_activity_code":"2222Z","business_number_type":"HM","country_calling_code":"33","criminal_proceedings":false,"income_statement_date":"20181231","financial_legal_events":false,"legal_form_description":"Joint Stock Company","financial_embarrassment":false,"financial_statement_date":"20181231","sic_activity_description":"MFG PLASTIC PRODUCTS","income_statement_date_end":"20181231","business_number_description":"Systeme Informatique pour le Repertoire des Etablissements (SIRET) Number"},"high_credit":304898,"quick_ratio":"5.954","year_period":true,"credit_score":[],"total_assets":16071060,"current_ratio":"6.348888","failure_score":[{"score":1445,"score_date":"20250916","algorithm_id":"FR43075","score_commentaries":[{"code":"BG/1114"},{"code":"BG/NB9","description":"Business has a parent or ultimate parent."},{"code":"BG/1132"},{"code":"BG/1185"},{"code":"BG/1193"},{"code":"BG/N26","description":"Indication of moderate industry risk classification"},{"code":"BG/N01","description":"Control age or date entered in D&B files indicates lower risk."},{"code":"BG/1125"},{"code":"BG/1180"},{"code":"BG/N89","description":"Payment experiences suggest potential lower risk."},{"code":"BG/1138"}],"national_percentile":68}],"liquid_assets":2073785,"previous_sales":13457286,"total_payments":14,"global_ultimate":{"duns":"371379034","country":"LU","dnb_key":"1b22d5289e0de210c3393cc582994d87","trade_name":"Ayrton International S.à r.l."},"location_status":"SL","accounts_audited":true,"accounts_payable":1209834,"claims_indicator":false,"export_indicator":true,"indate_indicator":true,"domestic_ultimate":{"duns":"269804284","country":"FR","dnb_key":"1f9376aaa698c935f00706690af205ee","trade_name":"COSMELUX INTERNATIONAL"},"figures_estimated":false,"total_liabilities":2331870,"previous_net_worth":12652035,"accounts_receivable":1758811,"average_high_credit":53782,"global_failure_score":[],"paydex_score_earlier":76,"total_current_assets":13879449,"is_subsidiary_location":true,"main_branch_indication":true,"statement_consolidated":false,"previous_statement_date":"20171231","total_current_liabilities":2186123}'
        //                 }
        //             });
        //         }, 500)
        //     }));
        // }

        if (provider === 'dun_brad_street' && parseInt(urlUtils.getOrganizationId()) === 2 && supplierId === 7286) {
            return await (new Promise((res) => {
                setTimeout(() => {
                    res({
                        "company": {
                            "id": 4,
                            "source": "dun_brad_street",
                            "idInSource": "96429aae822b79a9ae9e42074bbd3f5f",
                            "duns": "315621557",
                            "businessNumber": "70190B360610",
                            "businessNumberType": "20",
                            "primaryName": "HUGO BOSS AG",
                            "tradeName": null,
                            "formerDuns": null,
                            "formerPrimaryName": null,
                            "establishmentAddress": "Holy-Allee 3",
                            "establishmentAddressPostCode": "72555",
                            "establishmentAddressCity": "Metzingen",
                            "establishmentAddressRegion": "Baden-Württemberg",
                            "establishmentAddressCountry": "Germany",
                            "establishmentAddressRegionShort": "BW",
                            "establishmentAddressRegionCode": null,
                            "establishmentAddressCountryDnb": "0",
                            "establishmentAddressCountryIso": "DE",
                            "countryCallingCode": "49",
                            "phoneNumber": "1",
                            "faxNumber": "07123 9480259",
                            "marketabilityIndication": null,
                            "establishmentDeliverabilityIndication": true,
                            "correspondenceDeliverabilityIndication": true,
                            "correspondenceAddress": null,
                            "locationStatus": "HQ",
                            "isSubsidiaryLocation": false,
                            "legalForm": "3",
                            "lineOfBusiness": "Mfg men's/boy's clothing",
                            "linkageReportDate": null,
                            "familyMemberCount": "310",
                            "shareholderGraphData": null,
                            "ultimateShareholderData": null,
                            "officialDocumentData": null,
                            "organizationData": null,
                            "handelsregisterRegister": null,
                            "handelsregisterNumber": null,
                            "handelsregisterCourt": null,
                            "deleted": false,
                            "createdAt": null,
                            "updatedAt": null,
                            "createdBy": null,
                            "updatedBy": null
                        },
                        "company_shareholders": [
                            {
                                "id": 10,
                                "address": "Holy-Allee 3",
                                "name": "HUGO BOSS AG",
                                "duns": "315621557",
                                "postcode": "72555",
                                "city": "Metzingen",
                                "region": "Baden-Württemberg",
                                "country": "Germany",
                                "regionShort": "BW",
                                "regionCode": null,
                                "countryDnb": 0,
                                "countryIso": "DE",
                                "companyType": "domestic",
                                "deleted": false,
                                "createdAt": null,
                                "updatedAt": null
                            },
                            {
                                "id": 11,
                                "address": "Holy-Allee 3",
                                "name": "HUGO BOSS AG",
                                "duns": "315621557",
                                "postcode": "72555",
                                "city": "Metzingen",
                                "region": "Baden-Württemberg",
                                "country": "Germany",
                                "regionShort": "BW",
                                "regionCode": null,
                                "countryDnb": 0,
                                "countryIso": "",
                                "companyType": "global",
                                "deleted": false,
                                "createdAt": null,
                                "updatedAt": null
                            },
                            {
                                "id": 12,
                                "address": "Holy-Allee 3",
                                "name": "HUGO BOSS AG",
                                "duns": "315621557",
                                "postcode": "72555",
                                "city": "Metzingen",
                                "region": "Baden-Württemberg",
                                "country": "Germany",
                                "regionShort": "BW",
                                "regionCode": null,
                                "countryDnb": 0,
                                "countryIso": "",
                                "companyType": "headquarters",
                                "deleted": false,
                                "createdAt": null,
                                "updatedAt": null
                            }
                        ],
                        "management_team": [
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 1,
                                "fullName": "Daniel Heinrich Grieder",
                                "positions": "Chief Executive Officer",
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 2,
                                "fullName": "ZIGNAGO HOLDING SPA",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 3,
                                "fullName": "PFC SRL",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 4,
                                "fullName": "Luca Marzotto",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 5,
                                "fullName": "Stephan Sturm",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 6,
                                "fullName": "Oliver Timm",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 7,
                                "fullName": "Oliver Timm",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 8,
                                "fullName": "Christina Rosenberg",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 9,
                                "fullName": "Yves Marc Müller",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 10,
                                "fullName": "Yves Marc Müller",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 11,
                                "fullName": "Katharina Steimle",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 12,
                                "fullName": "Jochen Eckhold",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 13,
                                "fullName": "Ivica Maric",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 14,
                                "fullName": "Eva Katharina Herzog",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 15,
                                "fullName": "Iris Elisabeth Epple-Righi",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 16,
                                "fullName": "Frasers Group plc",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 17,
                                "fullName": "Nikolai Florian Clifford Vokuhl",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 18,
                                "fullName": "Jan Philipp Wintjes",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 19,
                                "fullName": "Dorothee Niebergall",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 20,
                                "fullName": "Luis Gonzaga Martinez Riesgo",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 21,
                                "fullName": "Sinan Piskin",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": true,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 22,
                                "fullName": "Eduard Spitz",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 23,
                                "fullName": "Merrill Lynch International PUC",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 24,
                                "fullName": "Tanja Silvana Nitschke",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 25,
                                "fullName": "Daniela Liburdi",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 26,
                                "fullName": "Claudia Hülsken",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 27,
                                "fullName": "Andreas Kurali",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 28,
                                "fullName": "Laura Micati",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 29,
                                "fullName": "Michael Murray",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            }
                        ],
                        "financial_summary": {
                            "id": 4,
                            "sicActivityCodes": [
                                {
                                    "code": "2329",
                                    "description": "Mfg men's/boy's clothing"
                                },
                                {
                                    "code": "2339",
                                    "description": "Mfg women's/misses' outerwear"
                                },
                                {
                                    "code": "2325",
                                    "description": "Mfg men's/boy's trousers"
                                },
                                {
                                    "code": "2311",
                                    "description": "Mfg men's/boy's suits/coats"
                                },
                                {
                                    "code": "2387",
                                    "description": "Mfg apparel belts"
                                },
                                {
                                    "code": "3172",
                                    "description": "Mfg personal leather goods"
                                }
                            ],
                            "sic8ActivityCodes": null,
                            "localActivityCode": "1413",
                            "localActivityCodeType": "360",
                            "startYear": null,
                            "statementDate": "20241231",
                            "annualSales": "4307349000",
                            "annualSalesUs": "4555056000",
                            "currency": null,
                            "netWorth": "1450111000",
                            "netWorthUs": "1533504000",
                            "netIncome": "223594000",
                            "netIncomeUs": "236452000",
                            "employees": null,
                            "employeesTotal": "21179",
                            "reportDate": "20250808",
                            "outOfBusiness": false,
                            "source": null,
                            "rawData": [],
                            "returnOnSales": null,
                            "equityRatio": null,
                            "returnOnEquity": null,
                            "earningsCAGR": null,
                            "revenuePerEmployee": null,
                            "tax": null,
                            "taxRatio": null,
                            "cash": null,
                            "salaries": null,
                            "salaryPerEmployee": null,
                            "materials": null,
                            "pensionProvisions": null,
                            "realEstate": null,
                            "receivables": null,
                            "balanceTotal": null,
                            "deleted": false,
                            "createdAt": null,
                            "updatedAt": null
                        }
                    })
                },
                1000);
            }))
        }

        const response = await axios.get(`${this.resource}/supplier/${orgIdInSource}/fetch-from-source`, {
            params: {
                provider,
                supplier_id: supplierId
            },
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data
    } 

    async fetchOrgDetailsForPDF(orgIdInSource, provider, supplierId = null){
        const urlUtils = new UrlUtils();
        if (provider === 'dun_brad_street' && parseInt(urlUtils.getOrganizationId()) === 2 && supplierId === 7286) {
            return await (new Promise((res) => {
                setTimeout(() => {
                    res({
                        "company": {
                            "id": 4,
                            "source": "dun_brad_street",
                            "idInSource": "96429aae822b79a9ae9e42074bbd3f5f",
                            "duns": "315621557",
                            "businessNumber": "70190B360610",
                            "businessNumberType": "20",
                            "primaryName": "HUGO BOSS AG",
                            "tradeName": null,
                            "formerDuns": null,
                            "formerPrimaryName": null,
                            "establishmentAddress": "Holy-Allee 3",
                            "establishmentAddressPostCode": "72555",
                            "establishmentAddressCity": "Metzingen",
                            "establishmentAddressRegion": "Baden-Württemberg",
                            "establishmentAddressCountry": "Germany",
                            "establishmentAddressRegionShort": "BW",
                            "establishmentAddressRegionCode": null,
                            "establishmentAddressCountryDnb": "0",
                            "establishmentAddressCountryIso": "DE",
                            "countryCallingCode": "49",
                            "phoneNumber": "1",
                            "faxNumber": "07123 9480259",
                            "marketabilityIndication": null,
                            "establishmentDeliverabilityIndication": true,
                            "correspondenceDeliverabilityIndication": true,
                            "correspondenceAddress": null,
                            "locationStatus": "HQ",
                            "isSubsidiaryLocation": false,
                            "legalForm": "3",
                            "lineOfBusiness": "Mfg men's/boy's clothing",
                            "linkageReportDate": null,
                            "familyMemberCount": "310",
                            "shareholderGraphData": null,
                            "ultimateShareholderData": null,
                            "officialDocumentData": null,
                            "organizationData": null,
                            "handelsregisterRegister": null,
                            "handelsregisterNumber": null,
                            "handelsregisterCourt": null,
                            "deleted": false,
                            "createdAt": null,
                            "updatedAt": null,
                            "createdBy": null,
                            "updatedBy": null
                        },
                        "company_shareholders": [
                            {
                                "id": 10,
                                "address": "Holy-Allee 3",
                                "name": "HUGO BOSS AG",
                                "duns": "315621557",
                                "postcode": "72555",
                                "city": "Metzingen",
                                "region": "Baden-Württemberg",
                                "country": "Germany",
                                "regionShort": "BW",
                                "regionCode": null,
                                "countryDnb": 0,
                                "countryIso": "DE",
                                "companyType": "domestic",
                                "deleted": false,
                                "createdAt": null,
                                "updatedAt": null
                            },
                            {
                                "id": 11,
                                "address": "Holy-Allee 3",
                                "name": "HUGO BOSS AG",
                                "duns": "315621557",
                                "postcode": "72555",
                                "city": "Metzingen",
                                "region": "Baden-Württemberg",
                                "country": "Germany",
                                "regionShort": "BW",
                                "regionCode": null,
                                "countryDnb": 0,
                                "countryIso": "",
                                "companyType": "global",
                                "deleted": false,
                                "createdAt": null,
                                "updatedAt": null
                            },
                            {
                                "id": 12,
                                "address": "Holy-Allee 3",
                                "name": "HUGO BOSS AG",
                                "duns": "315621557",
                                "postcode": "72555",
                                "city": "Metzingen",
                                "region": "Baden-Württemberg",
                                "country": "Germany",
                                "regionShort": "BW",
                                "regionCode": null,
                                "countryDnb": 0,
                                "countryIso": "",
                                "companyType": "headquarters",
                                "deleted": false,
                                "createdAt": null,
                                "updatedAt": null
                            }
                        ],
                        "management_team": [
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 1,
                                "fullName": "Daniel Heinrich Grieder",
                                "positions": "Chief Executive Officer",
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 2,
                                "fullName": "ZIGNAGO HOLDING SPA",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 3,
                                "fullName": "PFC SRL",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 4,
                                "fullName": "Luca Marzotto",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 5,
                                "fullName": "Stephan Sturm",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 6,
                                "fullName": "Oliver Timm",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 7,
                                "fullName": "Oliver Timm",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 8,
                                "fullName": "Christina Rosenberg",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 9,
                                "fullName": "Yves Marc Müller",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 10,
                                "fullName": "Yves Marc Müller",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 11,
                                "fullName": "Katharina Steimle",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 12,
                                "fullName": "Jochen Eckhold",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 13,
                                "fullName": "Ivica Maric",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 14,
                                "fullName": "Eva Katharina Herzog",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 15,
                                "fullName": "Iris Elisabeth Epple-Righi",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 16,
                                "fullName": "Frasers Group plc",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 17,
                                "fullName": "Nikolai Florian Clifford Vokuhl",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 18,
                                "fullName": "Jan Philipp Wintjes",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 19,
                                "fullName": "Dorothee Niebergall",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 20,
                                "fullName": "Luis Gonzaga Martinez Riesgo",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 21,
                                "fullName": "Sinan Piskin",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": true,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 22,
                                "fullName": "Eduard Spitz",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 23,
                                "fullName": "Merrill Lynch International PUC",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 24,
                                "fullName": "Tanja Silvana Nitschke",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 25,
                                "fullName": "Daniela Liburdi",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 26,
                                "fullName": "Claudia Hülsken",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 27,
                                "fullName": "Andreas Kurali",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 28,
                                "fullName": "Laura Micati",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            },
                            {
                                "sanctionHits": 0,
                                "idInSource": null,
                                "id": 29,
                                "fullName": "Michael Murray",
                                "positions": null,
                                "pepsStatus": "UNKNOWN",
                                "sanctionStatus": "CLEAN",
                                "dateOfBirth": null,
                                "nationality": null,
                                "title": null,
                                "isActive": null,
                                "appointmentDate": null,
                                "notes": null,
                                "rawData": [],
                                "source": "dun_brad_street",
                                "isMarkedForScreening": false,
                                "firstName": null,
                                "lastName": null,
                                "birthPlaceCity": null,
                                "birthPlaceCountry": null,
                                "roles": [],
                                "roleDateFrom": null,
                                "roleDateTo": null
                            }
                        ],
                        "financial_summary": {
                            "id": 4,
                            "sicActivityCodes": [
                                {
                                    "code": "2329",
                                    "description": "Mfg men's/boy's clothing"
                                },
                                {
                                    "code": "2339",
                                    "description": "Mfg women's/misses' outerwear"
                                },
                                {
                                    "code": "2325",
                                    "description": "Mfg men's/boy's trousers"
                                },
                                {
                                    "code": "2311",
                                    "description": "Mfg men's/boy's suits/coats"
                                },
                                {
                                    "code": "2387",
                                    "description": "Mfg apparel belts"
                                },
                                {
                                    "code": "3172",
                                    "description": "Mfg personal leather goods"
                                }
                            ],
                            "sic8ActivityCodes": null,
                            "localActivityCode": "1413",
                            "localActivityCodeType": "360",
                            "startYear": null,
                            "statementDate": "20241231",
                            "annualSales": "4307349000",
                            "annualSalesUs": "4555056000",
                            "currency": null,
                            "netWorth": "1450111000",
                            "netWorthUs": "1533504000",
                            "netIncome": "223594000",
                            "netIncomeUs": "236452000",
                            "employees": null,
                            "employeesTotal": "21179",
                            "reportDate": "20250808",
                            "outOfBusiness": false,
                            "source": null,
                            "rawData": [],
                            "returnOnSales": null,
                            "equityRatio": null,
                            "returnOnEquity": null,
                            "earningsCAGR": null,
                            "revenuePerEmployee": null,
                            "tax": null,
                            "taxRatio": null,
                            "cash": null,
                            "salaries": null,
                            "salaryPerEmployee": null,
                            "materials": null,
                            "pensionProvisions": null,
                            "realEstate": null,
                            "receivables": null,
                            "balanceTotal": null,
                            "deleted": false,
                            "createdAt": null,
                            "updatedAt": null
                        }
                    })
                },
                1000);
            }))
        }

        const response = await axios.get(`${this.resource}/supplier/${orgIdInSource}/fetch-report-data`, {
            params: {
                supplier_id: supplierId,
                provider
            },
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data
    } 

    async getUltimateShareholders(id, params = {}) {
        const response = await axios.get(
            `${this.resource}/company/${id}/ultimate-shareholder`, 
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async getShareholdersGraph(id, params = {}) {
        const response = await axios.get(
            `${this.resource}/company/${id}/shareholder-graph`, 
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    async getDocuments(id, params = {}) {
        const response = await axios.get(
            `${this.resource}/company/${id}/official-document`, 
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }

    /**
     * All KYB provider reports fetched for a third party (same payload shape as KYB details).
     * GET /kyb/supplier/{supplierId}/reports
     */
    async fetchSupplierReports(supplierId, params = {}) {
        const response = await axios.get(
            `${this.resource}/supplier/${supplierId}/reports`,
            {
                params,
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );

        return response.data?.data ?? response.data;
    }
}
